<template>
    <div class="report">
        <div class="avatar">
            <div class="contianer dfx">
                <el-button class="go_back" @click="goBack">
                <img src="../assets/previous.svg" alt="返回上一级" />
                </el-button>
                <div class="column">{{ column }}</div>
            </div>
        </div>
        <div class="asstes" style="padding-top: 0;">
          <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
            <el-tab-pane :label="mainTabName" name="first">
              <el-form ref="form" :model="form" class="item"  v-for="item in combinedArray" :key="item.id">
                <div class="vatar">
                  <el-avatar icon="el-icon-user-solid" :size="size" :src="item.avatar"></el-avatar>
                </div>
                <div class="con">
                  <div class="text">
                    <div class="name" v-if="item.evalua_number"><span>编号：</span>{{item.evalua_number}}</div>
                    <div class="name"><span>姓名：</span>{{item.nickname}}</div>
                    <div class="num"><span>年龄：</span>{{item.age}}</div>
                  </div>
                  <div class="age">
                    <div class="sex"><span>性别：</span>{{item.sex}}</div>
                    <el-form-item>
                      <el-button type="primary"><!-- {{ item.status }} -->
                        <!-- <router-link to="/table">
                        <span v-if="item.status === 0">等待测评</span>
                        <span v-else-if="item.status === 1">等待报告</span>
                        <span v-else-if="item.status === 2">查看1报告</span>
                        </router-link> -->
                        <router-link  v-if="item.status === 0" to="/track">
                          <span>正在跟进</span>
                        </router-link>
                        <router-link  v-if="item.status === 5" :to="'/table?selected=' + item.id + '&nameStr=' + item.nickname">
                          <span>等待测评</span>
                        </router-link>
                        <router-link  v-else-if="item.status === 8" :to="'/evalua?selected=' + item.id + '&nameStr=' + item.nickname">
                          <span>进入测评</span>
                        </router-link>
                       <!--  <router-link  v-else-if="item.status === 11 || item.status*1 == 2" :to="'/evalua?selected=' + item.id + '&nameStr=' + item.nickname">
                          <span>查看报告</span>
                        </router-link> -->
                        <!-- <span @click="viewReport(item.id)">查看报告</span> --><!--这个是直接打开pdf-->
                        <router-link v-else-if="item.status*1 === 11|| item.status*1 == 2" :to="'/previewreporthtml?evalua_number=' + item.evalua_number + '&sid=' + item.sid ">查看报告</router-link>
                        <!-- <router-link v-else-if="item.status === 11" :to="'/evalua?selected=' + item.id + '&nameStr=' + item.nickname">查看报告</router-link> -->
                      </el-button>
                      <el-button type="primary" style="background: #32b12b;" v-if="item.status * 1 === 11">
                        <!-- <router-link to="/table">查看报告</router-link> /evalua?selected=8&nameStr=张小小-->
                        <!-- 要确认报告了才出现重测试 -->
                        <span style="font-size: 1rem;" @click="reEvaluate(item.id)">重新测评</span>
                      </el-button>
                    </el-form-item>
                  </div>
                </div>
              </el-form>
              <div class="item" v-if="loading || noMoreData" style="background: #f9dcdc;">
                <div v-if="loading" style="text-align: center;margin: 0 auto;">加载中...</div>
                <div v-if="noMoreData" style="text-align: center;margin: 0 auto;">没有更多数据！</div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="等待测评" v-if="!queryStatus" name="second">
              <el-form ref="form" :model="form" class="item"  v-for="item in combinedArray" :key="item.id">
                <div class="vatar">
                  <el-avatar icon="el-icon-user-solid" :size="size" :src="item.avatar"></el-avatar>
                </div>
                <div class="con">
                  <div class="text">
                    <div class="name"><span>姓名：</span>{{item.nickname}}</div>
                    <div class="num"><span>年龄：</span>{{item.age}}</div>
                  </div>
                  <div class="age">
                    <div class="sex"><span>性别：</span>{{item.sex}}</div>
                    <el-button type="primary">
                      <router-link to="/table">立即测评</router-link>
                    </el-button>
                  </div>
                </div>
              </el-form>
              <div class="item" v-if="loading || noMoreData" style="background: #f9dcdc;">
                <div v-if="noMoreData" style="text-align: center;margin: 0 auto;">没有更多数据！</div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="等待报告" v-if="!queryStatus" name="third">
              <el-form class="item"  v-for="item in combinedArray" :key="item.id">
                <div class="vatar">
                  <el-avatar icon="el-icon-user-solid" :size="size" :src="item.avatar"></el-avatar>
                </div>
                <div class="con">
                  <div class="text">
                    <div class="name"><span>姓名：</span>{{item.nickname}}</div>
                    <div class="num"><span>年龄：</span>{{item.age}}</div>
                  </div>
                  <div class="age">
                    <div class="sex"><span>性别：</span>{{item.sex}}</div>
                    <el-button type="primary">
                      <router-link :to="'/evalua?selected=' + item.id + '&nameStr=' + item.nickname">进入测评</router-link>
                    </el-button>
                  </div>
                </div>
              </el-form>
              <div class="item" v-if="loading || noMoreData" style="background: #f9dcdc;">
                <div v-if="loading" style="text-align: center;margin: 0 auto;">加载中...</div>
                <div v-if="noMoreData" style="text-align: center;margin: 0 auto;">没有更多数据！</div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="测评完成" v-if="!queryStatus" name="fourth">
              <el-form class="item"  v-for="item in combinedArray" :key="item.id">
                <div class="vatar">
                  <el-avatar icon="el-icon-user-solid" :size="size" :src="item.avatar"></el-avatar>
                </div>
                <div class="con">
                  <div class="text">
                    <div class="name"><span>姓名：</span>{{item.nickname}}</div>
                    <div class="num"><span>年龄：</span>{{item.age}}</div>
                  </div>
                  <div class="age">
                    <div class="sex" style="width: 60%;"><span>性别：</span>{{item.sex}}</div>
                    <el-button type="primary">
                      <!-- <router-link to="/table">查看报告</router-link> /evalua?selected=8&nameStr=张小小-->
                      <router-link :to="'/evalua?selected=' + item.id + '&nameStr=' + item.nickname">查看报告1</router-link>
                       
                    </el-button>
                    <el-button type="primary" style="background: #32b12b;" v-if="item.status * 1 === 11">
                      <!-- <router-link to="/table">查看报告</router-link> /evalua?selected=8&nameStr=张小小-->
                       <!-- 要确认报告了才出现重测试 -->
                      <span style="font-size: 1rem;" @click="reEvaluate(item.id)">重新测评</span>
                    </el-button>
                  </div>
                </div>
              </el-form>
              <div class="item" v-if="loading || noMoreData" style="background: #f9dcdc;">
                <div v-if="loading" style="text-align: center;margin: 0 auto;">加载中...</div>
                <div v-if="noMoreData" style="text-align: center;margin: 0 auto;">没有更多数据！</div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 隐藏的下载链接 -->
        <a ref="downloadLink" :href="downloadUrl" style="display: none" target="_blank"></a>
    </div>
</template>
<script>
import { getEvalualists, getUserList, viewReport ,userEditMultiple} from '@/api/app'
import { Loading } from 'element-ui'
export default {
  name: 'Student',
  data () {
    return {
      downloadUrl: '',
      column: '我的学员',
      activeName: 'first',
      size: 'large',
      page_no: 1,
      loading: false,
      noMoreData: false,
      items: [],
      fDatas: {},
      form: {},
      queryStatus: null,
      mainTabName: '全部'
    }
  },
  computed: {
    // 计算属性，用于合并数组
    combinedArray () {
      return [...this.items]
    }
  },
  created () {
    // 在组件创建时根据查询参数切换选项卡
    const tab = this.$route.query.tab
    if (tab) {
      this.activeName = tab
    }
    this.setDataInit()
  },
  mounted () {
    this.setDataInit()
    this.fetchData()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    reEvaluate(student_id) {
      // 重新测评的逻辑
      //user status = 5 //等待测评
      const params = {
        id: student_id,
        status: 5
      }
      const fData = userEditMultiple(params)
      fData.then(() => {
          //this.$message.success(`重新测评成功！`)
          this.$router.push('/table')
        }
      ).catch(() => {
          this.$message.error(`重新测评失败！`)
        }
      )
    },
    async viewReport (studentId) {
      this.dialogVisible3 = false
      // 查看报告的逻辑
      const result = await viewReport({
          student_id: studentId
      })
      // html
      // this.generatePDF(result.html)
      console.log(result)
      // 更新下载链接
      this.downloadUrl = result.url
      // 等待下一个DOM更新周期
      this.$nextTick(() => {
          // 触发虚拟点击
          this.$refs.downloadLink.click()
      })
    },
    goBack () {
      this.$router.go(-1)
    },
    setDataInit () {
      this.page_no = 1
      this.items = []
      this.fDatas = {}
      this.noMoreData = false
      this.queryStatus = this.$route.query.status || null
      if (this.queryStatus) {
        switch (this.queryStatus) {
          case '0':
            this.mainTabName = '跟进客户'
            break
          case '5':
            this.mainTabName = '等待测评'
            break
          case '8':
            this.mainTabName = '等待报告'
            break
          case '11':
            this.mainTabName = '测评完成' // '测评完成' '查看报告'
            break
          case '88':
            this.mainTabName = '测评历史'
            break
        }
      }
      if (this.$route.query.tabName) {
        this.mainTabName = this.$route.query.tabName
      }
    },
    async fetchData () {
      if (this.fDatas.count) {
        if (this.fDatas.count === this.items.length || this.fDatas.count < this.fDatas.page_size) {
          this.noMoreData = true
          // console.log('====小于1页====')
          return
        }
      }
      /* this.$message({
            message: '没有更多数据了',
            type: 'warning'
          }) */
      //  状态:0-等待测评,1-等待报告,2-查看报告
      let params = {
        page_no: this.page_no,
        page_size: 20
      }
      switch (this.activeName) {
        case 'first':
          break
        case 'second':
          params['status'] = [5]
          break
        case 'third':
          params['status'] = [8]
          break
        case 'fourth':
          params['status'] = [11]
          break
      }
      // 如果是从home点击的，需要带上status参数
      if (this.queryStatus) {
        switch (this.queryStatus) {
          case '88':
            params['status'] = [8, 11]
            break
          default:
            params['status'] = [this.queryStatus * 1]
            break
        }
      }
      // 显示加载层
      this.loadingInstance = Loading.service({ fullscreen: true })
      this.loadingInstance && this.loadingInstance.close()
      let newItems;
      if(this.queryStatus==88 || this.queryStatus==11){
        // 测评完成和历史记录需要从测评记录表获取，才有 evalua_number 和 sid
        if (this.queryStatus == 88) {
          params['status'] = [8, 11]
        } else {
          params['status'] = [11]
        }
        this.fDatas = await getEvalualists(params)
        newItems = this.fDatas.lists.map(item => {
          const newItem = { ...item }
          newItem.sex = newItem.student_info && newItem.student_info.sex
          newItem.nickname = (newItem.student_info && newItem.student_info.nickname) || newItem.student_name
          newItem.avatar = newItem.student_info && newItem.student_info.avatar
          newItem.sid = (newItem.student_info && newItem.student_info.id) || newItem.student_id
          // evalua_number 来自 EvaluaRecord 表，展开已有
          if (newItem.sex * 1 === 1) {
            newItem.sex = '男'
          } else if (newItem.sex * 1 === 2) {
            newItem.sex = '女'
          }
          return newItem
        })
      }else{
        this.fDatas = await getUserList(params)
        newItems = this.fDatas.lists.map(item => {
          const newItem = { ...item }
          // 普通学员列表没有 evalua_number，用 id 兜底 sid
          newItem.sid = newItem.id
          if (newItem.sex * 1 === 1) {
            newItem.sex = '男'
          } else if (newItem.sex * 1 === 2) {
            newItem.sex = '女'
          }
          return newItem
        })
      }
      
      // console.log(newItems)
      if (newItems.length === 0) {
        this.noMoreData = true
      } else {
        this.items = [...this.items, ...newItems]
        this.page_no++
      }
    },
    async handleTabClick () {
      // console.log(this.activeName)
      this.setDataInit()
      await this.fetchData()
    },
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // console.log('===scrollTop====:', scrollTop)
      const windowHeight = window.innerHeight
      // console.log('===windowHeight====:', windowHeight)
      const documentHeight = document.documentElement.scrollHeight
      // console.log('===documentHeight====:', documentHeight)
      if (windowHeight === documentHeight) {
        return
      }
      if (scrollTop + windowHeight >= documentHeight - 10 && windowHeight !== documentHeight) {
        // console.log('===handleScroll====:')
        if (!this.noMoreData) {
          this.fetchData()
        }
      }
    }
  },
  watch: {
    // 监听选项卡的变化，变化时重新获取数据
    /* activeName: async function (newVal, oldVal) {
      // console.log('activeName changed from:', oldVal, 'to:', newVal)
      this.setDataInit()
      await this.fetchData()
    }, */
    '$route.query.tab' (newTab) {
      if (newTab) {
        this.activeName = newTab
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Student.vue